import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 시리즈 알림 상태 설정
 *
 * Origin: pageNicolasApi.setSeriesAlarm
 * API: POST /api/v2/store/set/seriesalarm
 */
export async function postStoreSetSeriesAlarm(
  {
    series_id,
    state,
  }: {
    series_id: number;
    state: boolean;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v2/store/set/seriesalarm',
    {
      method: 'POST',
      data: {
        series_id,
        state,
      },
    },
    options
  );

  return response.data;
}
